<template>
  <div class="demandReport" id="taskPlanContainer">
    <div class="leftDiv">
      <div class="leftBottomDiv">
        <div class="buttons">
          <div class="buttonClass" @click="addPointClick">
            新增航点
          </div>
        </div>
        <div class="contentClass">
          <div class="tableTitle">
            <div class="title">航点信息</div>
          </div>
          <div>
            <el-table
              ref="airPointList"
              height="320"
              :data = "landPoints"
              :row-style="{ height: '40px' }"
              :cell-style="changeCellStyle"
              :row-class-name="tableRowClassName"
              style="width: 92%"
              tooltip-effect="light"
              class="taskTable"
            >
              <el-table-column
                v-for="item in DataControlColumn"
                :key="item.id"
                :prop="item.prop"
                :label="item.label"
                :min-width="item.width"
                :show-overflow-tooltip="true"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="type"
                label="类型"
                align="center"
                min-width="2"
                :show-overflow-tooltip="true"
                >
                <template slot-scope="scope">
                  <span v-if="scope.row.type === 0">普通航点</span>
                  <span v-if="scope.row.type === 1">临时起降点</span>
                  <span v-if="scope.row.type === 2">起降点</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <div class="leftBottomDiv">
        <div class="buttons">
          <div class="buttonClass" @click="addLineClick">
            新增航线
          </div>
        </div>
          <div class="contentClass">
            <div class="tableTitle">
              <div class="title">航线信息</div>
            </div>
            <div>
              <el-table
                ref="airLineList"
                height="350"
                :data = "airLines"
                :row-style="{ height: '40px' }"
                :cell-style="changeCellStyle"
                :row-class-name="tableRowClassName"
                style="width: 92%"
                tooltip-effect="light"
                class="taskTable"
              >
                <!-- <el-table-column
                  prop="localId"
                  label="航线编号"
                  min-width="80"
                  :show-overflow-tooltip="true"
                  align="center"
                > -->
<!--                </el-table-column>-->
                <el-table-column
                  prop="name"
                  label="航线名称"
                  align="center"
                  min-width="80"
                  :show-overflow-tooltip="true"
                >
                </el-table-column>
                <el-table-column
                  prop="airpointlist"
                  label="包含航点信息"
                  align="center"
                  min-width="80"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    {{ getAirpointNames(scope.row.airpointList) }}
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </div>
      <!-- <div class="leftBottomDiv">
        <div class="buttons">
          <div class="buttonClass" @click="addLineClick">
            新增航线
          </div>
        </div>
        <div class="contentClass">
          <div class="tableTitle">
            <div class="title">航线信息</div>
          </div>
          <div>
            <el-table
              ref="airLineList"
              height="350"
              :row-style="{ height: '40px' }"
              :cell-style="changeCellStyle"
              :row-class-name="tableRowClassName"
              style="width: 92%"
              tooltip-effect="light"
              class="taskTable"
            >
              <el-table-column
                v-for="item in DataControlColumn"
                :key="item.id"
                :prop="item.prop"
                :label="item.label"
                :min-width="item.width"
                :show-overflow-tooltip="true"
                align="center"
              >
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div> -->
    </div>
    <div class="centerDiv">
    <div v-show="pointClickButton">
      <div class="centerTopDiv">
        <div class="formTitle">
          <div class="taskInfo">
            <div class="descOfNo">新增航点信息</div>
          </div>
        </div>

        <div :class="formClass">
          <el-form ref="taskFormPoint" :model="taskFormPoint" @submit.native.prevent>
            <el-row>
              <el-col :span="10" v-for="item in fromPoint" :key="item.id">
                <div class="firstRow">
                  <el-form-item :label="item.name" :prop="item.field">
                    <el-input
                      v-if="item.type == 'text'"
                      class="formInputClass"
                      :placeholder="item.placeholder"
                      :maxlength="item.ength"
                      v-model="taskFormPoint[item.field]"
                    >
                    </el-input>
                    <!-- <el-date-picker
                      v-if="item.type == 'datetime'"
                      popper-class="datePickerClass"
                      class="formInputClass"
                      :placeholder="item.placeholder"
                      :maxlength="item.length"
                      v-model="taskFormPoint[item.field]"
                      type="datetime"
                    >
                    </el-date-picker>                     -->
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <el-col>
                <div class="firstRow">
                  <el-form-item label="类型"  prop="type">
                    <el-select
                      v-model="taskFormPoint.type"
                      placeholder="请选择类型"
                      popper-class="adminHomeSelect"
                      >
                      <el-option
                        v-for="option in options"
                        :key="option.id"
                        :label="option.name"
                        :value="option.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </div>
      <div class="rightBottomDiv">
        <el-button class="editButton" @click="submitPoint('taskFormPoint')">
          提交
        </el-button>
      </div>
    </div>
    <div  v-show="lineClickButton">
      <div class="centerTopDiv topdiv">
        <div class="formTitle">
          <div class="taskInfo">
            <div class="descOfNo">新增航线信息</div>
          </div>
        </div>

        <div :class="formClass">
          <el-form
            ref="taskFormLine"
            :model="taskFormLine"
            @submit.native.prevent
          >
            <div class="row linerow">

              <el-form-item label="航线名称" prop="name">
                <el-input
                  class="formInputClass"
                  placeholder="请填写航线名称"
                  v-model="taskFormLine.name"
                >
                </el-input
              ></el-form-item>
              </div>
            <div class="row linerow">
              <el-form-item label="航点信息"  prop="airpointlist">
                <el-select
                  v-model="taskFormLine.airpointlist"
                  multiple
                  placeholder="请选择航点信息"
                  popper-class="adminHomeSelect"
                  ><el-option
                    v-for="landPoint in landPoints"
                    :key="landPoint.id"
                    :label="landPoint.name"
                    :value="landPoint.id"
                  ></el-option>
                </el-select>
            </el-form-item>
            </div>
            </el-form>
        </div>
        <!-- <div :class="formClass">
          <el-form ref="taskFormLine" :model="taskFormLine" @submit.native.prevent>
            <el-row>
              <el-col :span="100" v-for="item in fromLine" :key="item.id">
                <div class="firstRow">
                  <el-form-item :label="item.name" :prop="item.field">
                    <el-input
                      v-if="item.type == 'text'"
                      class="formInputClass"
                      :placeholder="item.placeholder"
                      :maxlength="item.ength"
                      v-model="taskFormLine[item.field]"
                    >
                    </el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div> -->
      </div>
      <div class="rightBottomDiv">
        <el-button class="editButton" @click="submitLine('taskFormLine')">
          提交</el-button
        >
      </div>
    </div>
    </div>
  </div>
</template>
<script type="text/javascript">
import taskIcon from "../../assets/img/home/task.png";
export default {
  name: "DataControl",

  data() {
    return {

      //航点数据
      landPoints: [],
      airLines: [],
      airPointList: [
        {
          id:"",
          airportId: "",
          name: "",
          latitude: "",
          longitude: "",
          altitude: "",
          type: ""
        }
      ],

       //航线数据
      airLineList: [
        {
          localId: "",
          name: "",
          airpointlist: "",
        }
      ],
      //表头数据
      DataControlColumn: [
        {
          id: "1",
          prop: "airportId", //对应字段
          label: "航点编号", //中文表头
          width: 2
        },
        {
          id: "2",
          prop: "name", //对应字段
          label: "航点名称", //中文表头
          width: 2
        },
        {
          id: "3",
          prop: "latitude", //对应字段
          label: "纬度", //中文表头
          width: 2
        },
        {
          id: "4",
          prop: "longitude", //对应字段
          label: "经度", //中文表头
          width: 2
        },
        {
          id: "5",
          prop: "altitude", //对应字段
          label: "高度", //中文表头
          width: 2
        },
        // {
        //   id: "6",
        //   prop: "type", //对应字段
        //   label: "类型", //中文表头
        //   width: 2
        // }
      ],
      pointClickButton: false,
      lineClickButton: false,
      taskIcon: taskIcon,
      openedId: null, //已展开的任务
      isDetail: false,
      formClass: "",
      options:[
        {id:"0" , name:"普通航点"},
        {id:"1" , name:"临时起降点"},
        {id:"2" , name:"起降点"},
      ],
      //新增表单的所有字段
      fromPoint: [

        {
          id: "2",
          name: "航点名称",
          field: "name",
          length: "10",
          placeholder: "请输入",
          type: "text",
          popperClass: ""
        },
        {
          id: "3",
          name: "纬度",
          field: "latitude",
          length: "10",
          placeholder: "请输入",
          type: "text",
          popperClass: ""
        },
        {
          id: "4",
          name: "经度",
          field: "longitude",
          length: "10",
          placeholder: "请输入",
          type: "text",
          popperClass: ""
        },
        {
          id: "5",
          name: "高度",
          field: "altitude",
          length: "10",
          placeholder: "请输入",
          type: "text",
          popperClass: ""
        },
        // {
        //   id: "6",
        //   name: "类型",
        //   field: "type",
        //   length: "10",
        //   placeholder: "请输入",
        //   type: "radio",
        //   popperClass: ""
        // }
      ],
      //新增航线表单的字段
      fromLine: [
        // {
        //   id: "1",
        //   name: "航线编号",
        //   field: "localId",
        //   length: "100",
        //   placeholder: "请输入",
        //   type: "text",
        //   popperClass: ""
        // },
        {
          id: "2",
          name: "航线名称",
          field: "name",
          length: "100",
          placeholder: "请输入",
          type: "text",
          popperClass: ""
        },
        {
          id: "3",
          name: "航点信息",
          field: "airpointlist",
          length: "100",
          placeholder: "请输入",
          type: "text",
          popperClass: ""
        }
      ],
      taskFormPoint: {
        airportId: "",
        name: "",
        latitude: "",
        longitude: "",
        altitude: "",
        type: "",
      },
      taskFormLine:{
        localId: "",
        name: "",
        airpointlist: "",
      }
    };
  },
  mounted() {
    this.$nextTick(function () {
      this.getWaypointData();
      this.getAirLineData();
    });
  },
  methods: {
    addPointClick() {
      this.rightCenterDiv = "centerDiv";
      this.formClass = "form";
      this.pointClickButton = true;
      this.restPointParams();
    },
     addLineClick() {
      this.rightCenterDiv = "centerDiv";
      this.formClass = "form";
      this.lineClickButton = true;
      this.restLineParams();
    },
     restPointParams() {
      // 重置航点表单内容
      this.taskFormPoint = {
        airportId: "",
        name: "",
        latitude: "",
        longitude: "",
        altitude: "",
        type: ""
      };
    },
     restLineParams() {
      // 重置航线表单内容
      this.taskFormLine = {
        localId: "",
        name: "",
        airpointlist: "",
      };
    },
    tableRowClassName({ row, rowIndex }) {
      if (this.openedId === row.id) {
        return "focusRowStyle";
      }
      return "rowStyle";
    },
    changeCellStyle(row, column, rowIndex, columnIndex) {
      if (row.column.label === "优先级") {
        return "color:#FFA63E;padding: 0;"; //修改的样式
      } else {
        return "color:#FFFFFF;padding: 0;";
      }
    },
    submitPoint() {
      //this.airPointList.push(this.taskFormPoint);
      let params = { ...this.taskFormPoint };
      this.addPoint(params);
      this.getWaypointData();
      this.pointClickButton = false;
    },
    addPoint(param) {
      this.postJsonRequest(
         "/uav-task-server/cpoint/addCPoint",param
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.$message({
            message: "提交成功",
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () {},
          });
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    submitLine() {
       let params = {
                    ...this.taskFormLine
                  };
       params.airpointlist = params.airpointlist.join(",")
                  this.addLine(params);
       this.$nextTick(function () {
         this.getAirLineData();
       });
      this.lineClickButton = false;
    },
    getWaypointData(){
      this.getRequest("/uav-task-server/cpoint/queryAllCPoint?pagesize=700&currentpage=1")
        .then((res) => {
          let oData = res.data;
          if (0 == oData.code) {
            let pointData = oData.data;
            let pointDataList=pointData.list;
            if (pointDataList) {
              this.landPoints = pointDataList;
            } else {
              this.landPoints = [];
            }
          } else if (oData.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },

    addLine(param) {
      this.postJsonRequest(
         "/uav-task-server/cairline/addCAirline",param
      ).then((res) => {
        let oData = res.data;
        if (oData.code === 0) {
          this.$message({
            message: "提交成功",
            duration: 1000,
            customClass: "message-s",
            iconClass: "el-icon-ok-tip",
            offset: 470,
            onClose: function () {},
          });
        } else if (oData.code != 401) {
          let tips = "<i class='el-icon-warn-tip'></i>" + oData.msg;
          this.$confirm(tips, "提示", {
            confirmButtonText: "好的",
            customClass: "confirmClass-style",
            iconClass: "",
            confirmButtonClass: "confirm",
            dangerouslyUseHTMLString: true,
            showCancelButton: false,
          });
        }
      });
    },
    getAirLineData(){
      this.getRequest("/uav-task-server/cairline/queryAllCAirline?pagesize=500&currentpage=1")
        .then((res) => {
          let oData = res.data;
          if (0 == oData.code) {
            let pointData = oData.data;
            let pointDataList=pointData.list;
            if (pointDataList) {
              this.airLines = pointDataList;
            } else {
              this.airLines = [];
            }
          } else if (oData.code != 401) {
            // let msg = "请求数据失败";
            // if (!this.isEmptyStr(res.msg)) {
            //   msg = res.msg;
            // }
            // let tips = "<i class='el-icon-warn-tip'></i>" + msg;
            // this.$confirm(tips, "提示", {
            //   confirmButtonText: "好的",
            //   customClass: "customClass-style",
            //   iconClass: "",
            //   dangerouslyUseHTMLString: true,
            //   confirmButtonClass: "confirm-style",
            //   showCancelButton: false,
            // });
          }
        })
        .catch((error) => {});
    },
    newDate(time) {
      var date = new Date(time);
      var y = date.getFullYear();
      var m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date.getDate();
      d = d < 10 ? "0" + d : d;
      return y + "-" + m + "-" + d;
    },
    // 处理包含航点信息
    getAirpointNames(airpoints) {
      // 提取每个航点的name属性，并拼接
      return airpoints.map(point => point.name).join(', ');
    },
  }
};
</script>
<style scoped>
@import "../../assets/css/home/DataControl.css";
</style>
<style></style>



// WEBPACK FOOTER //
// src/components/home/DataControl.vue